import { getDomainConfig } from '../domainConfig';
import { DEV_MODE } from './devMode';

export function getCookieDomain(): string | undefined {
  return DEV_MODE ? undefined : getDomainConfig().cookieDomain;
}
